import { NormalTableRow, SmallContentTableRow, SmallTextTableRow } from "../Settings"
import SliderCell, { ISliderCell } from "./SliderCell"
import TextCell from "./TextCell"

interface ISliderRow extends ISliderCell{
    mobile?: boolean,
    textTitle: string,
    subtitle: string
}

const SliderRow: React.FC<ISliderRow> = (props) => {
 
    const getSlider = () => {
        return(
            <SliderCell
                title={props.title}
                option={props.option}
                defaultOption={props.defaultOption}
                setOption={props.setOption}
                valueLabel={props.valueLabel}
                minValue={props.minValue}
                maxValue={props.maxValue}
                lockMaxValue={props.lockMaxValue}
                lockMinValue={props.lockMinValue}
                type={props.type}
                active={props.active}
                info={props.info}
                colspan={3}
                steps={props.steps}
                basic={props.basic}
                noWarningMsg={props.noWarningMsg}
                alwaysWarningMsg={props.alwaysWarningMsg}
                badValueRange={props.badValueRange}
                dontShowWarningMsg={props.dontShowWarningMsg}
            />
        )
    }

    return (
        props.mobile?
            <>
            <SmallTextTableRow>
                <TextCell colspan={3} title={props.textTitle} subtitle={props.subtitle}/>
            </SmallTextTableRow>
            <SmallContentTableRow>
                {getSlider()}
            </SmallContentTableRow>
            </>
            :
            <NormalTableRow>
                <TextCell title={props.textTitle} subtitle={props.subtitle}/>
                {getSlider()}
            </NormalTableRow>
        )
}

export default SliderRow